module.exports = __webpack_public_path__ + "static/media/brooch_1.883dacb9.jpg";